<template>
	<CModal title="Modifier l'adresse" size="lg" :show.sync="showModal" :key="orderItem.date">
		<form
			autocomplete="off"
			ref="mainForm"
			:action="orderAddressId ? orderAddressId : '/api/order_addresses'"
			:axiosMethod="orderAddressId ? 'patch' : 'post'">
			<CRow>
				<CCol col="12">
					<GTreeView
						placeholder="Rechercher une adresse.."
						:multiple="false"
						v-on:update:selected="onAddressSelection"
						:load-options="loadOptions"
						:default-options="true"
						:async="true" />
				</CCol>
			</CRow>

			<hr />

			<CInput v-model="type" name="type" hidden />

			<CRow>
				<CCol col="6">
					<CInput :value="customerAddress.lastName" name="lastName" label="Nom" />
				</CCol>
				<CCol col="6">
					<CInput :value="customerAddress.firstName" name="firstName" label="Prénom" />
				</CCol>
				<CCol col="12">
					<CInput
						:value="customerAddress.companyName"
						name="companyName"
						label="Dénomination sociale" />
				</CCol>

				<CCol col="12">
					<hr />
				</CCol>

				<CCol col="12">
					<div class="form-group">
						<label>Prédiction d'adresse</label>
						<GTreeView
							placeholder="Adresse"
							:multiple="false"
							v-on:update:selected="onSearchAddressSelection"
							:load-options="searchAddress"
							:async="true" />
					</div>
				</CCol>

				<CCol col="12">
					<hr />
				</CCol>

				<CCol col="12">
					<CInput v-model="customerAddress.address" name="address" label="Adresse" />
				</CCol>
				<CCol col="12">
					<CInput v-model="customerAddress.address2" name="address2" label="Complément d'adresse" />
				</CCol>

				<CCol col="4">
					<CInput v-model="customerAddress.postalCode" name="postalCode" label="Code postal" />
				</CCol>

				<CCol col="4">
					<CInput v-model="customerAddress.city" name="city" label="Ville" />
				</CCol>

				<CCol col="4">
					<div class="form-group">
						<CInput label="Pays" value="France" disabled />
						<CInput name="country" v-model="customerAddress.country" hidden />
						<!--            <GTreeView-->
						<!--              input-name="country"-->
						<!--              fetch-url="/api/countries?itemsPerPage=246"-->
						<!--              :multiple="false"-->
						<!--              placeholder="Choisissez un pays..."-->
						<!--              v-on:update:selected="(id) => (customerAddress.country = id)"-->
						<!--              :value="customerAddress.country"-->
						<!--            />-->
					</div>
				</CCol>

				<CCol col="6">
					<GInputPhoneNumber
						class="phone-input-container"
						v-model="customerAddress.phone"
						inputName="phone"
						label="Téléphone" />
				</CCol>
			</CRow>

			<hr />
		</form>

		<template #footer>
			<CButton color="danger" v-on:click="clear">Nouvelle adresse</CButton>
			<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
			<GLoadingButton
				color="primary"
				class="d-inline-block"
				label="Sauvegarder"
				:loading="loading"
				v-on:click="onSubmit" />
		</template>
	</CModal>
</template>

<script>
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';
	import GInputPhoneNumber from '../../../../../components/ghostlexly-components/GInputs/GInputPhoneNumber';
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';

	export default {
		name: 'edit-address',
		components: { GLoadingButton, GInputPhoneNumber, GTreeView },

		props: {
			customer: Object,
		},

		data() {
			return {
				addressForm: null,
				orderAddressId: null,
				customerAddress: {
					firstName: null,
					lastName: null,
					phone: null,
					address: null,
					address2: null,
					postalCode: null,
					city: null,
					country: '/api/countries/FR',
				},
				loading: false,
				showModal: false,
				orderItem: {},
				type: 'receiver',
			};
		},

		watch: {
			customerAddress(newVal) {
				// remove the @id from the country variable
				if (newVal.country && newVal.country['@id']) {
					newVal.country = newVal.country['@id'];
				}
			},
		},

		methods: {
			async onSubmit() {
				// (COLIKADO ONLY)
				// --> Verify if the destination address is not for Reunion
				if (this.customerAddress.country === '/api/countries/RE') {
					this.$toast.error('Vous ne pouvez pas envoyer des COLIKADO vers la Réunion !');
					return false;
				}

				if (this.customerAddress.postalCode.startsWith('974')) {
					this.$toast.error(
						'Code postal incorrect - Vous ne pouvez pas expédier des Colikado à la Réunion !'
					);
					return false;
				}

				this.loading = true;

				// update order_address entity
				try {
					await this.$formDataToApi.sendForm(this.$refs.mainForm).then(res => {
						this.loading = false;

						if (res.status === 200 || res.status === 201) {
							this.orderAddressId = res.data['@id'];
							this.customerAddress = res.data;
						} else {
							throw 'Adresse invalide';
						}
					});
				} catch (err) {
					return false;
				}

				// update address entity
				if (this.customerAddress.fromAddress) {
					await this.$axios.patch(this.customerAddress.fromAddress, { ...this.customerAddress });
				} else {
					// create an address for this new order_address
					let tmp = this.customerAddress;
					delete tmp['@id'];

					await this.$axios
						.post('/api/addresses', {
							...tmp,
							type: this.type,
							owner: this.customer['@id'],
							country: this.customerAddress.country,
						})
						.then(res => {
							this.$axios.patch(this.orderAddressId, { fromAddress: res.data['@id'] });
						});
				}

				// update order item
				this.$axios
					.patch(this.orderItem['@id'], { receiverAddress: this.orderAddressId })
					.then(res => {
						this.$toast.success('Sauvegardé avec succès');
						this.$emit('refresh');
						this.showModal = false;
						this.loading = false;
					})
					.catch(err => {
						this.$toast.error(err.response.data['hydra:description']);
					});
			},

			clear() {
				this.orderAddressId = null;
				this.customerAddress = {
					firstName: null,
					lastName: null,
					phone: null,
					address: null,
					address2: null,
					postalCode: null,
					city: null,
					country: '/api/countries/FR',
				};
			},

			async onAddressSelection(data) {
				// create an order_address entity from address entity
				let address = null;
				await this.$axios.get(data).then(res => {
					address = res.data;
				});

				let tmp = Object.assign({}, address);
				delete tmp['@id'];

				await this.$axios
					.post('/api/order_addresses', {
						...tmp,
						fromAddress: address['@id'],
					})
					.then(res => {
						this.orderAddressId = res.data['@id'];
						this.customerAddress = res.data;
					});
			},

			searchAddress({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('query', searchQuery);

					this.$google.findPlacesFromQuery(searchQuery, ['fr']).then(res => {
						const options = res.map(item => {
							return {
								'@id': item.place_id,
								name: item.description,
							};
						});

						callback(null, options);
					});
				}
			},

			onSearchAddressSelection(item) {
				this.$google.findByPlaceId(item).then(res => {
					this.customerAddress.address =
						this.$google.findAddressComponent(res, 'street_number').long_name +
						' ' +
						this.$google.findAddressComponent(res, 'route').long_name;

					this.customerAddress.city = this.$google.findAddressComponent(res, 'locality').long_name;
					//this.customerAddress.country = `/api/countries/${this.$google.findAddressComponent(res, "country").short_name}`;

					this.customerAddress.postalCode = this.$google.findAddressComponent(
						res,
						'postal_code'
					).long_name;
				});
			},

			loadOptions({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);
					params.append('owner', this.customer['@id']);
					params.append('type', 'receiver');

					this.$axios.get(`/api/addresses?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = `${item.lastName} ${item.firstName} - ${item.postalCode} ${item.city}`;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						callback(null, options);
					});
				}
			},
		},
	};
</script>
